import React from 'react'
import { Card, CardBody, CardHeader, CurrencyDisplay, generateColorFromIndex } from '@aidkitorg/component-library'
import { useLocalizedStrings } from '../../../Localization'
import { Account } from '@aidkitorg/aidkit/lib/admin_panel/accounts'

type AccountDetailsCardProps = {
  index: number,
  account: Account,
  className?: string,
}

export const AccountDetailsCard = ({ index, account, className }: AccountDetailsCardProps) => {
  const L = useLocalizedStrings()

  const cardHeader = (
    <div className="flex flex-row flex-wrap justify-between">
      <div className="font-medium break-normal">{account.name}</div>
      <div>
        <div className="p-1"
          style={{
            display: 'inline-block',
            width: 15,
            height: 15,
            backgroundColor: generateColorFromIndex(index),
            borderRadius: '50%',
          }}
        /></div>
    </div>
  )

  return (
    <Card className={className}> 
      <CardHeader title={cardHeader}/>
      <CardBody className="pt-2">
        <div>
          <div className="text-2xl font-medium text-[var(--ak-color-typography-text)]">
            <CurrencyDisplay locale="en-US" currency="USD" value={0.01 * account.totalBalance}/>
          </div>
          <div className="text-sm text-gray-500 font-medium">{L.admin_panel.accounts.available_balance}</div>
        </div>
      </CardBody>
    </Card>
  )
}